import { apiClient } from "../config";
async function addPerson(data: any) {
  const res = await apiClient.post("/admin/users/person", data);
  return res.data;
}

export default addPerson;
